import { createContext } from 'react';
import {  } from '../hook/useDynamicSubTableHook';
import { FormInstance } from "antd/lib/form";

export interface IBaseDynamicSubTableContext {
  dataSource?: any[];
  form?: FormInstance;
  expandedRowKeys?: string[];
}
export interface IDynamicSubTableContext extends IBaseDynamicSubTableContext {
  
}
export default createContext<IDynamicSubTableContext>({
  
});